import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { GenericComponent } from '../../../../layouts/custom-component/generic-component';
import { UtenteService } from '../_service/UtenteService';
import { Utente } from '../_model/Utente';

@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-wrapper",
    templateUrl: 'home.component.html',
    providers: [UtenteService]
})
export class HomeComponent /*extends GenericComponent*/ {

    /*
    blockedUI: boolean = false;
    msgs: Message[] = [];

    utenti: Utente[];
    constructor(private us: UtenteService) {
        super(us);
    }
    ngOnInit() {
        this.genericCallService("getAll", null).then(data => {
            this.utenti = data["userList"];
            
        }).catch(error => {  });

    }

    test() {
        this.msgs.push({ severity: 'info', summary: 'Success', detail: "Operazione eseguita con successo" });

        let utente = new Utente()
        utente.nome = "Filippo";
        utente.cognome = "AAA";
        utente.matricola = "1054127"

        this.utenti.push(utente);
    }*/

}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/home/home.component.ts